import {DATASET_MIXPANEL} from 'common/report/constants';

import {queryApiUrl} from '../utils';
import {BaseClient} from '../utils/base-client';
import {getEventParam, processPropertyValues} from './utils';

class EventPropertyValuesClient extends BaseClient {
  buildEndpoint() {
    return queryApiUrl(`events/properties/values`);
  }

  buildQueryParams(params: {projectId: string}) {
    return {
      project_id: params.projectId,
    };
  }

  buildRequestBody({
    customProperty = null,
    dataGroupId = null,
    dataGroupPropertyName = null,
    datasetId = DATASET_MIXPANEL,
    eventName = null,
    ignoreListItem = false,
    limit = null,
    objectProperty = null,
    propertyName = null,
    specialErfParams = null, // only to be used by ERF, passes a flag and uses special params that behave differently in normal queries
    tempDataGroupId = null,
    workspaceId = null,
  }: {
    customProperty?: Record<string, any> | null;
    dataGroupId?: string | null;
    dataGroupPropertyName?: string | null;
    datasetId?: string | null;
    eventName?: string | null;
    ignoreListItem?: boolean;
    limit?: number | null;
    objectProperty?: Record<string, any> | null;
    propertyName?: string[] | string | null;
    specialErfParams?: Record<string, any> | null;
    tempDataGroupId?: string | null;
    workspaceId?: string | null;
  }) {
    return JSON.stringify({
      // Property could be of type array or string
      ...(propertyName ? {name: Array.isArray(propertyName) ? JSON.stringify(propertyName) : propertyName} : {}),
      ...(customProperty
        ? {property: JSON.stringify({...customProperty, ...(dataGroupPropertyName ? {dataGroupPropertyName} : {})})}
        : {}),
      ...(objectProperty
        ? {
            property: JSON.stringify(objectProperty),
          }
        : {}),
      ...getEventParam(eventName),
      ...(datasetId !== DATASET_MIXPANEL ? {dataset_name: datasetId} : {}),
      ...(dataGroupId ? {data_group_id: dataGroupId} : {}),
      ...(tempDataGroupId ? {temp_data_group_id: tempDataGroupId} : {}),
      ...(workspaceId ? {workspace_id: workspaceId} : {}),
      ...(limit ? {limit} : {}),
      ...(ignoreListItem ? {ignore_list_item: true} : {}),
      ...(specialErfParams ? {...specialErfParams, erf_autodetection_query: true} : {}),
    });
  }

  processResponse(response: string[] | {error: string; request: string}, {propertyName}: {propertyName: string}) {
    if (`error` in response) {
      throw new Error(response.error);
    }
    return processPropertyValues(response, {propertyName});
  }
}

export const eventPropertyValuesClient = new EventPropertyValuesClient();

export type EventPropertyValuesParams = Omit<
  Parameters<(typeof eventPropertyValuesClient)[`buildRequestBody`]>[0],
  `workspaceId`
> & {
  projectId: string | number;
  workspaceId?: string | number;
};
